import { MortgageSourceTag, MortgageTag } from '@core/util/tags';
import {
	MatterDocumentType,
	MortgageDocumentSource,
} from '@models/matter-file';
import { MatterMortgageWithAssociations } from '@models/mortgage';
import { TrustAccount } from '@models/trustAccount';
import { Selector } from '@ngxs/store';
import { TrustAccountsState } from '@state/business/trustAccounts/trustAccounts.state';
import {
	MergedUploadedMatterDocumentSelectors,
	VirtualizedMatterFile,
} from '@state/global/uploaded-documents/upload-documents';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { cloneDeep } from 'lodash';

export interface SelectedUploadedDoc extends VirtualizedMatterFile {
	selected: boolean;
}

export class CloserSyncMortgageDetailsSelectors {
	@Selector([
		MergedUploadedMatterDocumentSelectors.getUploadedDocs,
		MatterMortgagesState.getSelectedMortgage,
		TrustAccountsState.getAll,
	])
	static getUserUploadedDocs(
		uploadedDocs: VirtualizedMatterFile[],
		mortgage: MatterMortgageWithAssociations,
		trustAccounts: TrustAccount[],
	): SelectedUploadedDoc[] {
		if (!mortgage?.id) {
			return [];
		}

		const selectedUploadedDocs = [];

		if (mortgage?.fundingDetails?.trustAccount?.id) {
			const trustAccount = trustAccounts?.find(
				(x) => x.id === mortgage?.fundingDetails?.trustAccount?.id,
			);
			if (trustAccount?.voidCheque) {
				const matterFileVoidCheque: VirtualizedMatterFile = {
					id: 'voidCheque',
					url: trustAccount?.voidCheque,
					name: 'Void Cheque',
					type: MatterDocumentType.MORTGAGE,
					uploadedAt: null,
					fileType: null,
					systemTags: ['formType:voidCheque'],
				};
				selectedUploadedDocs.push(matterFileVoidCheque);
			}
		}

		const mortgageDocs = uploadedDocs
			?.filter(
				(doc) =>
					doc?.systemTags?.includes(MortgageTag(mortgage.id)) &&
					doc?.systemTags?.includes(
						MortgageSourceTag(MortgageDocumentSource.USER_UPLOAD),
					),
			)
			.sort((a, b) => a?.uploadedAt - b?.uploadedAt);

		selectedUploadedDocs.push(...cloneDeep(mortgageDocs));

		return selectedUploadedDocs?.filter((x) => !!x) as SelectedUploadedDoc[];
	}

	@Selector()
	static getUndeletableUserUploadedDocIds(): string[] {
		return ['voidCheque'];
	}
}
